import './SuggestedMentors.css';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { CaseIcon } from '@components/Icons';
import StartSession from '../../../components/StartSession';
import { MentorBase } from '../../../types/mentor';

export interface SuggestedMentorItem {
  mentor: MentorBase;
  slug?: string;
}
interface LocationState {
  prevLocation?: string;
}
export const SuggestedMentorItem: React.FC<SuggestedMentorItem> = ({
  mentor,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const locationState = location.state as LocationState;

  return (
    <div key={mentor.mentorId} className="text-white">
      <div className="w-full bg-gray-200 md:flex items-center justify-center overflow-hidden rounded-lg mb-2 hidden">
        <video
          disablePictureInPicture
          loop
          autoPlay
          playsInline
          muted
          src={mentor.videoLoopUrl}
          poster={mentor.previewUrl}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex md:flex-col items-center  md:items-start gap-2 md:gap-0">
        <div className="w-[40px] h-[40px] min-w-[40px] md:hidden">
          <img
            src={mentor.previewUrl}
            className="object-cover w-full h-full rounded-full md:hidden"
          />
        </div>
        <div>
          <p className="font-semibold capitalize">{`${mentor.firstName} ${mentor.lastName}`}</p>
          <p className="text-xs mb-2 h-16 overflow-auto">{mentor.reason}</p>
          <div className="flex flex-wrap items-center gap-1 mb-4 text-neutral-200 h-8">
            <div className="flex items-center gap-1 text-xs">
              <CaseIcon size={12} /> {mentor.jobTitle}
            </div>
          </div>
        </div>
      </div>
      <StartSession
        url={`/${mentor.slug}${location.search}`}
        text={t('generation.switchOver')}
        location={locationState?.prevLocation || '/'}
        className="relative !min-w-[146px] !max-w-[146px] flex mx-auto rounded-lg !text-xs !md:text-md "
      />
    </div>
  );
};
